import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Leaderboard as LeaderboardUI } from './LeaderboardUI'
import { MaxWidthWrapper } from 'components/styles'
import { useRouteContext } from 'contexts/RouteContext'
import { useLazyQuery } from '@apollo/client'
import { get_fe_leaderboards } from '@tiltify/ui/gql/queries/leaderboards'
import { formatFELeaderboards } from '@tiltify/ui/utils/formatNewLeaderboards'

const MaxWidthWrapperAlt = styled(MaxWidthWrapper)`
  padding: 1rem;
  z-index: 1;
  margin-top: 2rem;
`

interface ILeaderboardInfo {
  amount: TiltifyCurrency
  amountRaised: string
  total: string
  avatar: TiltifyImage
  heat: number
  id: string
  name: string
  url: string
}

interface ICustomLeaderboards {
  individual?: Array<ILeaderboardInfo>
  team?: Array<ILeaderboardInfo>
  weekly?: Array<ILeaderboardInfo>
}

interface IDonorLeaderboards {
  donors?: Array<ILeaderboardInfo>
}

export const Leaderboard = (): JSX.Element | null => {
  const { cause, fundraisingEvent } = useRouteContext()
  const [leaderboards, updateLeaderboards] = useState<ICustomLeaderboards>()
  const [donorLeaderboards, updateDonorLeaderboards] = useState<IDonorLeaderboards>()

  const [getLeaderboards, leaderboardsData] = useLazyQuery(get_fe_leaderboards, {
    variables: { publicId: fundraisingEvent?.publicId },
  })

  useEffect(() => {
    const getDonorLeaderboards = async () => {
      let tempLeaders = {}

      await fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/custom/yoggscast`, {
        credentials: 'include',
        method: 'GET',
      })
        .then((res) => res.json())
        .then((data) => (tempLeaders = { donors: data.data }))

      return updateDonorLeaderboards(tempLeaders)
    }

    getDonorLeaderboards()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!fundraisingEvent) return

    getLeaderboards()
    // eslint-disable-next-line
  }, [fundraisingEvent])

  useEffect(() => {
    if (!leaderboardsData?.loading && leaderboardsData?.data)
      formatFELeaderboards(leaderboardsData, updateLeaderboards)
  }, [leaderboardsData])

  if (!leaderboards && !donorLeaderboards) return null

  const individualCampaigns = leaderboards?.individual && leaderboards?.individual.length > 0
  const teamCampaigns = leaderboards?.team && leaderboards?.team.length > 0
  const donorCampaigns = donorLeaderboards?.donors && donorLeaderboards?.donors.length > 0

  if (!individualCampaigns && !teamCampaigns && !donorCampaigns) {
    return null
  }

  return (
    <MaxWidthWrapperAlt>
      <LeaderboardUI
        leaderboards={leaderboards}
        donorLeaderboards={donorLeaderboards}
        currency={cause?.paymentMethods[0]?.currency ?? 'usd'}
      />
    </MaxWidthWrapperAlt>
  )
}
